import Template from '@/ui/templates/Course';
import Head from '@/ui/utils/Head';
import { Course, getCourses, Movie } from '@/utils/lesson-course';

import type { GetStaticPaths, GetStaticProps, NextPage } from 'next';

type ServerProps = {
  course: Course;
  movie: Movie;
  index: number;
};

type Params = {
  courseId: string;
  index: string;
};

const Page: NextPage<ServerProps> = ({ course, movie, index }) => {
  return (
    <>
      <Head
        image={course.imageUrl}
        keywords={['卓球', '卓球動画', '卓球情報']}
        description={course.description.substring(0, 150)}
        title={`${course.title} - 卓球レッスン動画／動画でまなぶ卓球 シェークハンズ`}
      />
      <Template course={course} movie={movie} index={index} />
    </>
  );
};

export default Page;

export const getStaticPaths: GetStaticPaths = async () => {
  const courses = getCourses();

  return {
    fallback: false,
    paths: courses
      .map(course =>
        course.movies.map((_, index) => ({
          params: { courseId: course.id, index: (index + 1).toString() },
        })),
      )
      .flat(),
  };
};

export const getStaticProps: GetStaticProps<ServerProps, Params> = async ({
  params,
}) => {
  const { courseId, index: strIndex } = params as NonNullable<typeof params>;
  const index = +strIndex - 1;

  const course = getCourses().find(course => course.id === courseId);

  if (!course) {
    return { notFound: true };
  }

  const movie = course.movies[index];
  if (!movie) {
    return { notFound: true };
  }

  return { props: { course, movie, index } };
};
